import classnames from "classnames";
import PropTypes from "prop-types";
import styles from "./grid.module.css";

function Grid(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <ul {...props} className={classnames(styles.grid, props.className)}>
      {props.children}
    </ul>
  );
}

Grid.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export function GridItem(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <li {...props} className={classnames(/*"aspect-square transition-opacity",*/ props.className)}>
      {props.children}
    </li>
  );
}

GridItem.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default Grid;
